<template>
  <crud-base
    :url="url"
    :columns="columns"
    :onDelete="() => {}"
    :onUpdate="() => {}"
    :onStore="() => {}"
    :enableSearch="true"
    :checkAlerts="true"
    :formInputs="formInputs"
    primaryKey="id"
  />
</template>

<script>
import CrudBase from '../../../components/crud/CrudBase';
import { yesNoRepresentation } from '@/helpers/transformers';

export default {
  name: 'planos-restricao',
  components: { CrudBase },
  data() {
    return {
      url: '/admin/condicoes/plano-restricao',
      columns: [
        { label: 'ID', field: 'id', sortable: false },
        {
          label: 'Plano de Pagamento',
          field: 'plano_pagamento',
          sortable: false,
          representedAs: (row) =>
            row?.plano_pagamento
              ? `${row.planopagamento_id} - ${row.plano_pagamento.descricao}`
              : row.planopagamento_id,
        },
        {
          label: 'Cliente (Restrição)',
          field: 'cliente',
          sortable: false,
          representedAs: (row) =>
            row?.cliente
              ? `${row.restricao_id} - ${row.cliente.razaosocial}`
              : row.restricao_id,
        },
        {
          label: 'Ativo',
          field: 'ativo',
          sortable: false,
          representedAs: (row) => yesNoRepresentation(row.ativo),
        },
      ],
      formInputs: {
        id: {
          type: 'string',
          ui: {
            label: 'Identificador',
            columns: 4,
            widget: 'AutoIdWidget',
            widgetConfig: { campo1Key: 'planopagamento_id', campo2Key: 'restricao_id' },
          },
          rules: { required: { value: true, errMsg: 'Preencha o Identificador.' } },
        },
        planopagamento_id: {
          type: 'number',
          ui: {
            label: 'Plano de Pagamento',
            columns: 4,
            widget: 'SearchSelectWidget',
            widgetConfig: {
              searchUrl: '/admin/condicoes/planos',
              idField: 'id',
              labelField: 'descricao',
              preload: true,
              extraParams: { ativo: 1 },
            },
          },
          rules: { required: { value: true, errMsg: 'Campo obrigatório.' } },
        },
        restricao_id: {
          type: 'number',
          ui: {
            label: 'Cliente (Restrição)',
            columns: 4,
            widget: 'SearchSelectWidget',
            widgetConfig: {
              searchUrl: '/admin/clientes',
              idField: 'id',
              labelField: 'razSoc',
              labelFields: ['razSoc', 'fant'],
              preload: false,
            },
          },
          rules: { required: { value: true, errMsg: 'Campo obrigatório.' } },
        },
        ativo: {
          type: 'number',
          default: 1,
          ui: {
            label: 'Ativo',
            columns: 4,
            widget: 'select',
            widgetConfig: {
              placeholder: 'Selecione',
              enumSource: [{ label: 'Sim', value: 1 }, { label: 'Não', value: 0 }],
            },
          },
        },
      },
    };
  },
};
</script>
